import { forwardRef, useContext } from "react"

import { LocalizationContext } from "web/contexts"
import { useUnits } from "web/hooks/data"

import InputWithUnit from "./InputWithUnit/InputWithUnit"

const LengthInput = forwardRef((props, ref) => {
  const { defaultLengthUnit } = useContext(LocalizationContext)
  const [{ length_units: lengthUnits }] = useUnits()
  const supportedLengthUnitCodes = lengthUnits.map((c) => c.code)

  return (
    <InputWithUnit
      ref={ref}
      kind="Length"
      units={supportedLengthUnitCodes}
      defaultUnit={defaultLengthUnit}
      {...props}
    />
  )
})

export default LengthInput
